import { render, staticRenderFns } from "./WealthOrdersView.vue?vue&type=template&id=70c8eb6e&scoped=true&"
import script from "./WealthOrdersView.vue?vue&type=script&lang=ts&"
export * from "./WealthOrdersView.vue?vue&type=script&lang=ts&"
import style0 from "./WealthOrdersView.vue?vue&type=style&index=0&id=70c8eb6e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c8eb6e",
  null
  
)

export default component.exports